import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { handleError, isNotBusinessError } from '../../../utils/handleError';
import { AlertError } from '../../../components/bootstrap/AlertError';
import { Arrays } from '../../../utils/Arrays';
import { FormattedMessage, useIntl } from 'react-intl';
import { EnumSelectField } from '../../../components/bootstrap/EnumSelectField';
import { AlertSuccess } from '../../../components/bootstrap/AlertSuccess';
import { useNavigate } from 'react-router-dom';
import { LabelToolTip } from '../../../components/bootstrap/LabelToolTip';
import { EmptyResults } from '../../../components/general/EmptyResults';
import { SubTemplate } from '../../../components/general/SubTemplate';
import Loading from '../../../components/general/Loading';
import { CustomPagination } from '../../../components/general/CustomPagination';
import { Strings } from '../../../utils/Strings';
import { getEntityList } from '../../../rest/entity';
import { ListFilterBar } from '../../../components/general/ListFilterBar';
import { EntityState } from "../../../models/EntityState";
import Nav from 'react-bootstrap/Nav';
import { NavLinkFilter } from '../../../components/general/NavLinkFilter';
import {el} from "date-fns/locale";
import { useLocation } from "react-router";
import { getUserInfo } from '../../../authentication/authenticationHelper';
import { ConfigObject } from '../../../config';

const MAX_RESULTS = 10;
const DEFAULT_INITIAL_PAGE = 0;

export function ListEntities() {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [numberOfResults, setNumberOfResults] = useState(null);
	const [totalResults, setTotalResults] = useState(null);
	const [activeEventKey, setActiveEventKey] = useState('FULLY_APPROVED');

	const [entityList, setEntityList] = useState([]);

	const orderByOptionsIdPrefix = 'listEntities.list.orderOption';
	const orderByOptions = ['description_asc', 'description_desc', 'accreditationDate_asc', 'accreditationDate_desc'];

	const [currentOrderBy, setCurrentOrderBy] = useState(orderByOptions[0]);

	const userInfo = getUserInfo();
	const regionalDelegations = ConfigObject.get().regionalDelegationCodes;

	const { search } = useLocation();
	const params = new URLSearchParams(search);
	const [currentPage, setCurrentPage] = useState(params.get('page')!==null && params.get('page')!==DEFAULT_INITIAL_PAGE ? Number(params.get('page')) : DEFAULT_INITIAL_PAGE);
	const [filters, setFilters] = useState({
	    regionalDelegation: {
	        type: 'enum',
	        preffixDescriptionId: 'regionalDelegationFull',
	        options: regionalDelegations,
	        value: params.get('regionalDelegation')!==null && params.get('regionalDelegation')!==userInfo.rd ? params.get('regionalDelegation') : userInfo.rd,
	        nullOption: true,
	        nullOptionSuffix: 'regionalDelegation',
	        colSpace: 4
	    },
		name: { 
			type: 'text', 
			value: params.get('name')!==null && params.get('name')!=-'' ? params.get('name')  : '', 
			placeholderId: 'all.name', 
			colSpace: 3 
		},
		nipc: { 
			type: 'number', 
			value: params.get('nipc')!==null && params.get('nipc')!=-'' ? params.get('nipc')  : '', 
			placeholder: 'NIPC', 
			maxLength: 9, 
			colSpace: 2
		},
	});

	const [regionalDelegationCode, setRegionalDelegationCode] = useState(params.get('regionalDelegation')!==null && params.get('regionalDelegation')!==userInfo.rd ? params.get('regionalDelegation') : userInfo.rd);
	
	const tabs = {
		SUBMITTED: { labelId: 'entityState.SUBMITTED', value: 'SUBMITTED'},
		EVALUATION: { labelId: 'entityState.EVALUATION', value: 'EVALUATION'},
		FULLY_APPROVED: { labelId: 'entityState.FULLY_APPROVED', value: 'FULLY_APPROVED'},
		REVOKED: { labelId: 'revocationState.REVOKED', value: 'REVOKED'},
		CESSATION: { labelId: 'entityState.CESSATION', value: 'CESSATION'},
	}
	

	const hoverpreffixId = 'listEntities.list.hover';

	const navigate = useNavigate();

	const intl = useIntl();

	const [lsItem, setLsItem] = useState(null);

	const [showDelegationInName, setShowDelegationInName] = useState(false);

	function handleSearch() {
		const history = window.history;


		let currentUrlParams = new URLSearchParams(window.location.search);
		if(filters.name.value!== null && filters.name.value!== ''){
			currentUrlParams.set('name',filters.name.value);
		}else{
			currentUrlParams.delete('name');
		}
		if(filters.nipc.value!== null && filters.nipc.value!== ''){
			currentUrlParams.set('nipc',filters.nipc.value);
		}else{
			currentUrlParams.delete('nipc');
		}
		if(filters.regionalDelegation !== undefined) {
			if(filters.regionalDelegation.value!== null && filters.regionalDelegation.value!== userInfo.rd){
				currentUrlParams.set('regionalDelegation',filters.regionalDelegation.value);
				setRegionalDelegationCode(filters.regionalDelegation.value);
			}else{
				currentUrlParams.delete('regionalDelegation');
				setRegionalDelegationCode(userInfo.rd);
			}
		}

		const url = currentUrlParams.size==0 ? window.location.pathname : window.location.pathname + '?' + currentUrlParams.toString();
		history.replaceState({}, '', url);
		fetchData();
	}

	async function fetchData() {
		try {
			if(filters.name.value !=='' || filters.nipc.value!==''){
				setCurrentPage(0)
			}

			let orderParams = currentOrderBy.split('_');

			let queryparams = {
				index: (filters.name.value !=='' || filters.nipc.value!=='') ? 0 : currentPage,
				size: MAX_RESULTS,
				orderBy: orderParams[0],
				orderType: orderParams[1],
				revoked: false
			};

			if (!Strings.isBlank(filters.name.value)) {
				queryparams.name = filters.name.value;
			}

			if (!Strings.isBlank(filters.nipc.value)) {
				queryparams.nipc = filters.nipc.value;
			}

			if (!Strings.isBlank(activeEventKey) ) {
				if(EntityState.values().includes(activeEventKey)) {
					if (activeEventKey)
						queryparams.state = activeEventKey;
				} else if(activeEventKey === 'REVOKED') {
					queryparams.revoked = true;
				}
			}

			if (activeEventKey !== 'FULLY_APPROVED') {
				queryparams.regionalDelegation = userInfo.rd;
			} else if (filters.regionalDelegation === undefined) {
				queryparams.regionalDelegation = regionalDelegationCode === '-1' ? null : regionalDelegationCode;
			} else if (filters.regionalDelegation.value !== '-1') {
				queryparams.regionalDelegation = filters.regionalDelegation.value;
			}

			const [{ data: formList }] = await Promise.all([
				await getEntityList(queryparams),
			]);

			setEntityList(formList.results);
			setNumberOfResults(formList.numberOfResults);
			setTotalResults(formList.totalResults);

			setShowDelegationInName(activeEventKey === 'FULLY_APPROVED' && 
				(filters.regionalDelegation?.value === '-1' || regionalDelegationCode === '-1'));
			
		} catch (error) {
			setError(error);
		} finally {
			setLoading(false);
		}
	}

	const onPageChange = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	function handleOrderByChange(e) {
		setCurrentOrderBy(e.target.value);
	}

	function updateFiltersWhenChangingTabs() {
		if(activeEventKey === 'FULLY_APPROVED') {
			if(filters.regionalDelegation === undefined) {
				setFilters({regionalDelegation: {
						type: 'enum',
						preffixDescriptionId: 'regionalDelegationFull',
						options: regionalDelegations,
						value: regionalDelegationCode,
						nullOption: true,
						nullOptionSuffix: 'regionalDelegation',
						colSpace: 4
					},
					...filters
				});
			}
		} else {
			setFilters({name: filters.name, nipc: filters.nipc});
		}
	}

	useEffect(() => {
		checkStorageItems();
	}, []);

	useEffect(() => {
		updateFiltersWhenChangingTabs();
		setCurrentPage(0);
		fetchData();
	}, [activeEventKey]);

	useEffect(() => {
		const history = window.history;
		let currentUrlParams = new URLSearchParams(window.location.search);
		if(currentPage!== null && currentPage!== DEFAULT_INITIAL_PAGE){
			currentUrlParams.set('page',currentPage);
		}else{
			currentUrlParams.delete('page')
		}
		console.log(currentUrlParams);
		const url = currentUrlParams.size===0 ? window.location.pathname : window.location.pathname + '?' + currentUrlParams.toString();
		history.replaceState({}, '', url);

		fetchData();
	}, [currentPage]);

	if (loading) {
		return <Loading />;
	}

	if (error && isNotBusinessError(error)) {
		return handleError(error);
	}

	function checkStorageItems() {
		if (sessionStorage.getItem('eaAccreditationSubmited')) {
			setLsItem('eaAccreditationSubmited');
		}
	}

	console.log(entityList)

	return (
		<SubTemplate
			titleId={'listEntities.list.title'}
			hasBackButton
		>
			<Container>
				<div className='mx-2 mb-4'>
					<AlertSuccess lsItem={lsItem} />
				</div>
				<Row className='mb-4'>
					<NavLinkFilter tabs={tabs} defaultActiveKey={activeEventKey} setActiveEventKey={setActiveEventKey} />
				</Row>
				<Row>
					<Col md='10'>
						<ListFilterBar
							filters={filters}
							setFilters={setFilters}
							search={handleSearch}
						/>
					</Col>
				</Row>
				<Row className='searchResults'>
					<Col md='12'>
						<AlertError error={error} />

						{Arrays.isNotEmpty(entityList) ? (
							<>
								<Row className='mt-5 mb-1 d-flex justify-content-between px-2'>
									<Col className='text-muted'>
										{totalResults}{' '}
										<FormattedMessage
											id={`all.results.lowCase.${
												totalResults === 1 ? 'singular' : 'plural'
											}`}
										/>
									</Col>
									<Col md='4'>
										<EnumSelectField
											preffixDescriptionId={orderByOptionsIdPrefix}
											handleChange={handleOrderByChange}
											options={orderByOptions}
											value={currentOrderBy}
										/>
									</Col>
								</Row>
								<div className='list-header d-lg-block d-md-block d-sm-none d-xs-none'>
									<Row>
										<Col md='4' className='d-flex align-items-center'>
											<FormattedMessage id={'listEntities.list.hover.name'}/>
										</Col>
										<Col md='2' className='d-flex align-items-center'>
											<FormattedMessage id={'listEntities.list.hover.nipc'}/>
										</Col>
										<Col md='2' className='d-flex align-items-center'>
											<FormattedMessage id={'listEntities.list.hover.processId'}/>
										</Col>
										<Col md='2' className='d-flex align-items-center'>
											<FormattedMessage id={'listEntities.list.hover.state'}/>
										</Col>
										<Col md='2' className='d-flex align-items-center justify-content-center'>
											<FormattedMessage id={'listEntities.list.hover.accreditationDate'}/>

										</Col>
									</Row>
								</div>
								<ul className='results'>
									{entityList.map((entity, index) => (
										<li key={index}>
											<Row
												className='py-3'
												onClick={() => navigate(`/entidades/${entity.nif}`)}
											>
												<Col md='4' className='d-flex align-items-center'>
													<LabelToolTip
														labelId={`${hoverpreffixId}.name`}
														value={showDelegationInName ? entity.regionalDelegationCode + ' - ' + entity.description : entity.description
														}
													/>
												</Col>
												<Col md='2' className='d-flex align-items-center'>
													<LabelToolTip
														labelId={`${hoverpreffixId}.nipc`}
														value={entity.nif}
													/>
												</Col>
												<Col md='2' className='d-flex align-items-center '>
													<LabelToolTip
														labelId={`${hoverpreffixId}.processId`}
														value={entity.processId}
													/>
												</Col>
												<Col md='2' className='d-flex align-items-center '>
													<LabelToolTip
														labelId={`${hoverpreffixId}.processId`}

														value={<FormattedMessage id={entity.revoked ? 'accreditationRevocationState.APPROVED' : `entityState.${entity.state}`}/>}
													/>
												</Col>
												<Col
													md='2'
													className='d-flex align-items-center justify-content-center'
												>
													<LabelToolTip
														labelId={`${hoverpreffixId}.accreditationDate`}
														value={entity.accreditationDate=== undefined ? ' — ' : entity.accreditationDate}
													/>
												</Col>
											</Row>
										</li>
									))}
								</ul>
							</>
						) : (
							<EmptyResults />
						)}
					</Col>
				</Row>
				<Row className='mb-5'>
					<Col md='10' className='d-flex'>
						<div className='mx-2'>
							<CustomPagination
								dataPerPage={MAX_RESULTS}
								totalData={totalResults}
								onPageChange={onPageChange}
								currentPage={currentPage}
							/>
						</div>
					</Col>
				</Row>
			</Container>
		</SubTemplate>
	);
}
